module.exports = __webpack_public_path__ + "img/FoggyAndOnceShower.338ada3a.png";